import React from "react"
import TeacherFormContainer from "../Container/TeacherFormContainer"
import EmergencyContact2 from "./EmergencyContactForm2"
import { connect } from "react-redux"
import { updatePersonalDetails } from "../../redux/homePage/homePage.actions"
import { notify } from "react-notify-toast"

class emergencyContact2 extends React.Component {
  state = {
    emergency_contact_name: this.props.user.emergency_contact_name,
    emergency_contact_lastname: this.props.user.emergency_contact_lastname,
    emergency_contact_mobile_number: this.props.user
      .emergency_contact_mobile_number,
    emergency_contact_relationship: this.props.user
      .emergency_contact_relationship,
    medical_needs: this.props.user.medical_needs,
  }

  handleStateChange = (e) => {
    this.setState({ [e.target.id]: e.target.value })
  }

/*   validateMobileNumber(number) {
    let isValid = false
    if (number.substring(0, 2) === "04") {
      isValid = true
    }
    return isValid
  } */

  handleNumberChange = (event) => {
    console.log(event)
    this.setState({value:event})
    this.setState({emergency_contact_mobile_number: event})
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const fields = [
      "emergency_contact_name",
      "emergency_contact_lastname",
      "emergency_contact_mobile_number",
      "emergency_contact_relationship",
      "medical_needs",
    ]
    let errors = false

    /* for (let field of fields) {
      const input = document.getElementById(field)
      if (!input.reportValidity()) {
        errors = true
        break;
      }
    } */

    if (errors) {
      notify.show(
        "You are missing one or more field(s)!"
      )
    }

    /* if (
      !this.validateMobileNumber(this.state.emergency_contact_mobile_number)
    ) {
      notify.show(
        "Please enter an Australian mobile number, eg: 04XXXXXXXX (10 Digit)",
        "error"
      )
      errors = true
    } */

    if (!errors) {
      this.props.updatePersonalDetails({ ...this.state })
    }
  }

  tabs = [
    {
      pathname: "/personalDetails",
      text: "Personal Details",
    },
    {
      pathname: "/emergencyContact",
      text: "Emergency",
      active: true,
    },
    {
      pathname: "/preferredWorkLocations",
      text: "Work Locations",
    },
  ]

  render() {
    return (
      <div>
        <TeacherFormContainer
          header="Personal Information"
          tabs={this.tabs}
          handleSubmit={this.handleSubmit}
        >
          <EmergencyContact2
            handleStateChange={this.handleStateChange}
            handleNumberChange={this.handleNumberChange}
            state={this.state}
          />
        </TeacherFormContainer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePersonalDetails: (details) => dispatch(updatePersonalDetails(details)),
})

export default connect(mapStateToProps, mapDispatchToProps)(emergencyContact2)
